import Form from './Form.vue';
import withInstall from '@/shared/withInstall';

export const XForm = withInstall(Form);
export default XForm;
